import React from 'react';
import DynamicTable from "../../../../widgets/dynamicTable/DynamicTable";
import HelperMetiers360 from "../../../../../services/HelpersMetiers360.js";
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import Loader from '../../../../widgets/Loader';
import Webapp2ActivitiesPDFTable from './Webapp2ActivitiesPDFTable.jsx';

const Webapp2ActivitiesStats = ({ setModalData, modalData, setModalShow, clientById, activitiesStats }) => {

    const openWebapp2ActivityModal = (slug) => {
        setModalData({
            ...modalData,
            header: <>{activitiesStats?.find(s => s.slug == slug)?.title}</>,
            content: <Webapp2ActivitiesPDFTable slug={slug} clientUniqueId={clientById.uniqueId} />,
            size: 'lg',
            id: 'webapp2-user-modal'
        });
        setModalShow(true);
    }

    const handleClick = (val) => openWebapp2ActivityModal(val);

    const sortType = activitiesStats?.length > 0
        && [
            {
                value: 'title', label: 'Titre',
                test: HelperMetiers360.isArrayContainsValue(activitiesStats, "title"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.title, b.title),
                display: (activity) => activity.title ?? '-'
            },
            {
                value: 'endingCount', label: 'Réalisations',
                test: activitiesStats?.some(s => s.endingCount),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.endingCount, b.endingCount),
                display: (stat) => stat.endingCount
            },
            {
                value: 'userCount', label: 'Utilisateur⋅rices ayant réalisé',
                test: activitiesStats?.some(s => s.userCount),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.userCount, b.userCount),
                display: (stat) => stat.userCount
            },
            {
                value: 'currentCount', label: 'Utilisateur⋅rices ayant commencé',
                test: activitiesStats?.some(s => s.currentCount),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.currentCount, b.currentCount),
                display: (stat) => stat.currentCount
            },
            {
                value: 'clientHasAccess', label: 'Accessible',
                test: HelperMetiers360.isArrayContainsValue(activitiesStats, "clientHasAccess"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.clientHasAccess, b.clientHasAccess),
                display: (activity) => activity.clientHasAccess ? "Oui" : "Non"
            },
            {
                value: 'isDisplayed', label: 'Affichée',
                test: HelperMetiers360.isArrayContainsValue(activitiesStats, "isDisplayed"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.isDisplayed, b.isDisplayed),
                display: (activity) => activity.isDisplayed ? "Oui" : "Non"
            }
        ];

    return !activitiesStats ?
        <Loader />
        : activitiesStats?.length > 0 ?
            < DynamicTable
                contentTable={activitiesStats}
                contentSort={sortType}
                handleClick={handleClick}
                valueInitSort="title"
                index='slug'
                tableName={"webapp2ActivitiesStats"}
                filename={`${clientById['clientName']}-Webapp2ActivitiesStats-${HelperMetiers360.getdisplayDateType(new Date(), 'day')}`}
            />
            : <Alert variant='warning'>Pas de données disponibles.</Alert>;
};

Webapp2ActivitiesStats.propTypes = {
    clientById: PropTypes.object.isRequired,
    activitiesStats: PropTypes.array,
};

export default Webapp2ActivitiesStats;